<template>
    <HeaderView />

    <div class="container-fluid">

        <BannerView v-if="showBanner" />

        <div class="container mt-5">

            <div class="row">
                <div class="mission-container">
                    <p class="caption">Onze achtergrond</p>
                    <p>
                        LeefGoed is geworteld in de regio {{ CityName }} en kent een lange geschiedenis van betrokken
                        woningbeheer. Vanuit een stevige basis van grondgebonden woningen en appartementen groeide
                        de corporatie uit tot een organisatie die zich inzet voor ruim 10.000 huishoudens – in
                        stedelijke buurten, dorpskernen en het open landelijk gebied.
                    </p>
                </div>
            </div>
        </div>

        <div class="header-image image-3"></div>

        <div class="container mt-5">
            <div class="row">
                <div class="news-container">
                    <h2>Divers bezit, brede opdracht</h2>
                    <p>Ons woningbezit is zo divers als de regio zelf. Naast grondgebonden woningen en appartementen
                        beheren wij ook zorgvastgoed en gemengde complexen uit verschillende bouwperiodes. Die variatie
                        stelt ons in staat om voor een breed publiek passende woonruimte aan te bieden: van starters en
                        gezinnen tot ouderen en mensen met een zorgbehoefte.</p>

                    <h2>Meerdere gemeenten, één gezamenlijke opgave</h2>
                    <p>LeefGoed is actief in meerdere gemeenten in de regio {{ CityName }}, elk met een eigen lokale
                        dynamiek en politieke context. Wij werken nauw samen met gemeentebesturen om de woonopgave
                        per gemeente goed in te vullen. Die samenwerking is niet altijd eenvoudig – belangen
                        lopen soms uiteen – maar wij zoeken altijd naar oplossingen die recht doen aan alle betrokkenen.</p>

                    <h2>Leefbaarheid in alle wijken</h2>
                    <p>Onze woningen bevinden zich in uiteenlopende wijken: van levendige stadswijken tot rustige
                        dorpen en van welvarende buurten tot gebieden waar leefbaarheid onder druk staat. In al
                        deze omgevingen voelen wij ons verantwoordelijk voor meer dan alleen de stenen. Wij
                        investeren in veiligheid, sociale cohesie en de kwaliteit van de openbare ruimte.</p>

                    <h2>Financieel verantwoord en maatschappelijk betrokken</h2>
                    <p>Als corporatie beschikken wij over beperkte financiële middelen. Elke euro die wij
                        investeren – in nieuwbouw, onderhoud of verduurzaming – moet zorgvuldig worden afgewogen.
                        Wij streven naar financiële gezondheid op de lange termijn, zodat wij ook in de toekomst
                        kunnen blijven investeren in goed en betaalbaar wonen.</p>

                    <h2>Transparantie en goed bestuur</h2>
                    <p>LeefGoed hecht aan open communicatie met huurders, gemeenten, huurdersorganisaties en
                        andere stakeholders. Wij leggen verantwoording af over onze keuzes en nodigen betrokkenen
                        uit om mee te denken over de koers van de corporatie. Goed bestuur is voor ons geen
                        verplichting, maar een vanzelfsprekende houding.</p>

                    <p>LeefGoed: geworteld in de regio, gericht op de toekomst.</p>
                </div>
            </div>
        </div>

        <div class="header-image image-4" style="margin-top:3rem;"></div>
    </div>

    <FooterView />
</template>

<script>
import HeaderView from '@/components/HeaderView.vue';
import BannerView from '@/components/BannerView.vue';
import FooterView from '@/components/FooterView.vue';
import constants from '@/constants.js';

export default {
    name: 'AboutUs2',
    components: {
        HeaderView, BannerView, FooterView
    },
    data() {
        return {
            CityName: constants.CityName
        };
    }
};
</script>

<style scoped>
.container-fluid {
    margin-bottom: 3em;
}

.mission-container {
    box-sizing: border-box;
    max-width: 73.125rem;
    padding-bottom: 1.3125rem;
    background: white;
}

.fictional-client-mission {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 3.75rem;
}

.fictional-client-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}

.journey-guide {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding-bottom: 1.75rem;
    margin-left: 2.9375rem;
}

.fictional-client-text {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: 1.875rem;
}

.journey-guide1 {
    box-sizing: border-box;
    flex: 0 1 auto;
    margin-left: -1.1875rem;
}

.signature {
    font-size: 15pt;
    display: block;
    margin-top: 2rem;
}

.header-image {
    width: 100%;
    height: 11em;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.image-1 {
    background-image: url(@/assets/carousel_2.jpg);
}

.image-2 {
    background-image: url(@/assets/about-us.jpg);
}

.image-3 {
    background-image: url(@/assets/office-with-logo-a.jpg);
}

.image-4 {
    background-image: url(@/assets/office-with-logo.jpg);
}

.news-container {
    background: #f6f9ff;
    padding: 2.5em;
}

.news-container p {
    text-align: justify;
}

.news-container h2 {
    color: #444;
    font-weight: normal;
    margin-bottom: 0.5em;
    font-size: 1.9rem;
}
</style>